const STYLES = {
  draft: "bg-slate-500/15 text-slate-400 border-slate-500/30",
  generating: "bg-violet-500/15 text-violet-300 border-violet-500/40",
  ready: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
  approved: "bg-amber-500/15 text-amber-300 border-amber-500/40",
  failed: "bg-red-500/15 text-red-300 border-red-500/40",
};

export const StatusBadge = ({ status, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center px-2 py-0.5 rounded border font-mono text-[10px] uppercase tracking-wider ${STYLES[status] || STYLES.draft}`}>
    {status}
  </span>
);
